import React, { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from '~/Locale';
import {
  DeleteIcon,
  BodyText,
  SearchIcon,
  Spacer,
  TextField,
  Subtitle
} from '@kvdbil/components';
import {
  SearchAllArticlesDocument,
  SearchAllArticlesQuery
} from '~/config/generated/graphql';
import ArticleList from './ArticleList';
import { useCmsData } from '~/App/shared/hooks/useCmsData';
import { BlogSearchAllArticles } from '~/App/shared/interfaces/store/CmsData';

const BlogSearch = () => {
  const [isLoading, setLoading] = useState(false);
  const [query, setQuery] = useState('');

  const { data, fetching } = useCmsData<
    SearchAllArticlesQuery,
    BlogSearchAllArticles
  >({
    storeKey: 'blogSearchAllArticles',
    storeNestedKey: `query-${query}`,
    query: SearchAllArticlesDocument,
    options: { pause: !(query.length > 2), variables: { query } }
  });

  const { t } = useTranslation();

  useEffect(() => {
    if (query.length > 2) {
      setLoading(true);
      setTimeout(() => setLoading(false), 250);
    }
  }, [fetching, query]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
  };

  const handleClear = () => {
    setQuery('');
  };

  return (
    <>
      <TextField
        onKeyDown={e => e.key === 'Escape' && handleClear()}
        onChange={handleChange}
        value={query}
        label={t('Search among our articles')}
        placeholder={t('Search among our articles')}
        suffix={
          (query.length ?? 0 > 0) ? (
            <DeleteIcon onClick={handleClear} />
          ) : (
            <SearchIcon />
          )
        }
      />

      {data?.allArticles &&
        data?.allArticles?.length > 0 &&
        query.length > 0 && (
          <>
            <Spacer />
            <Subtitle>{t('Search results')}</Subtitle>
            <Spacer />
            <ArticleList isLoading={isLoading} articles={data?.allArticles} />
          </>
        )}

      {data?.allArticles &&
        data?.allArticles?.length === 0 &&
        query.length > 0 && (
          <>
            <BodyText>{t('No results were found for: %s', query)}</BodyText>
            <Spacer />
          </>
        )}
    </>
  );
};

export default BlogSearch;
